import Currency from "../../utils/services/localization/currencyService";
import listTemplate from "../../templates/listTemplate";

export default {
  namespaced: true,
  ...listTemplate(Currency)
};
